/* ==========================================================================
   THEME.JS — Global interactions: drawers, header, accordions, sliders
   ========================================================================== */
(function () {
  'use strict';

  var body = document.body;

  /* ---------------- Transparent header: solid once the hero it floats over is scrolled past ---------------- */
  (function () {
    var header = document.querySelector('[data-site-header].site-header--transparent');
    if (!header) return;
    var hero = document.querySelector('.section-hero-nofs');
    function threshold() {
      return hero ? hero.offsetHeight : (header.offsetHeight || 118);
    }
    function updateScrollState() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold());
    }
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);
  })();

  /* ---------------- Product card photo dots: click to switch the shown image ---------------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-dot-index]');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    var card = dot.closest('.product-card');
    if (!card) return;
    var index = dot.getAttribute('data-dot-index');
    card.querySelectorAll('[data-card-image]').forEach(function (img) {
      img.classList.toggle('is-active', img.getAttribute('data-image-index') === index);
    });
    card.querySelectorAll('[data-dot-index]').forEach(function (d) {
      d.classList.toggle('is-active', d === dot);
    });
  });

  /* ---------------- Collection filters: availability toggle navigates ---------------- */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-filter-toggle]');
    if (!toggle) return;
    window.location.href = toggle.checked ? toggle.getAttribute('data-url-on') : toggle.getAttribute('data-url-off');
  });

  /* ---------------- Drawers (cart, search, mobile-nav, filters, size-guide) ---------------- */

  function getDrawer(name) {
    return document.querySelector('[data-drawer="' + name + '"]');
  }

  function openDrawer(name, trigger) {
    var drawer = getDrawer(name);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('drawer-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    drawer.dataset.openedBy = trigger ? (trigger.getAttribute('data-drawer-toggle') || '') : '';

    var focusable = drawer.querySelector('input, button, a, [tabindex]');
    if (focusable) {
      window.setTimeout(function () { focusable.focus(); }, 150);
    }

    if (name === 'search') {
      var input = drawer.querySelector('[data-search-input]');
      if (input) window.setTimeout(function () { input.focus(); }, 150);
    }

    document.dispatchEvent(new CustomEvent('theme:drawer:open', { detail: { name: name } }));
  }

  function closeDrawer(name, restoreFocus) {
    var drawer = getDrawer(name);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('drawer-open');

    var toggles = document.querySelectorAll('[data-drawer-toggle="' + name + '"]');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });

    document.dispatchEvent(new CustomEvent('theme:drawer:close', { detail: { name: name } }));
  }

  window.theme = window.theme || {};
  window.theme.openDrawer = function (name) { closeAllDrawers(); openDrawer(name, document.querySelector('[data-drawer-toggle="' + name + '"]')); };
  window.theme.closeDrawer = closeDrawer;

  function closeAllDrawers() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (drawer) {
      closeDrawer(drawer.getAttribute('data-drawer'));
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      var name = toggle.getAttribute('data-drawer-toggle');
      var drawer = getDrawer(name);
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer(name);
      } else {
        closeAllDrawers();
        openDrawer(name, toggle);
      }
      return;
    }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.getAttribute('data-drawer-close'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
    }
  });

  /* ---------------- Mobile nav / FAQ / product accordions ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;
    var panel = toggle.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-accordion-panel')) return;

    var expanded = toggle.getAttribute('aria-expanded') === 'true';

    if (toggle.closest('.mobile-nav') || toggle.closest('.faq-accordion') || toggle.closest('.product-info')) {
      toggle.setAttribute('aria-expanded', String(!expanded));
      animateAccordionPanel(panel, !expanded);
    }
  });

  /* Open / close: height, padding and opacity ease together (450 ms, ease-in-out). Starts on the click itself,
     picks up from the current frame if toggled mid-way, and is skipped for "reduce motion". */
  function animateAccordionPanel(panel, open) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = null;
    if (panel._accordionAnim) {
      var running = getComputedStyle(panel);
      from = { height: running.height, paddingTop: running.paddingTop, paddingBottom: running.paddingBottom, opacity: running.opacity };
      panel._accordionAnim.cancel();
      panel._accordionAnim = null;
    }
    if (reduce || !panel.animate) {
      panel.hidden = !open;
      return;
    }

    if (open) panel.hidden = false;
    var shown = getComputedStyle(panel);
    var full = { height: shown.height, paddingTop: shown.paddingTop, paddingBottom: shown.paddingBottom, opacity: shown.opacity };
    var none = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: '0' };
    var start = from || (open ? none : full);
    var end = open ? full : none;

    panel.style.overflow = 'hidden';
    var anim = panel.animate([start, end], { duration: 450, easing: 'ease-in-out', fill: 'forwards' });
    panel._accordionAnim = anim;
    var done = function () {
      if (panel._accordionAnim !== anim) return;
      panel._accordionAnim = null;
      panel.hidden = !open;
      anim.cancel();
      panel.style.overflow = '';
    };
    anim.onfinish = done;
    window.setTimeout(done, 520);
  }

  /* ---------------- Announcement bar rotation ---------------- */
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var interval = parseInt(bar.getAttribute('data-auto-rotate'), 10);
    var items = bar.querySelectorAll('.announcement-bar__item');
    if (!interval || items.length < 2) return;
    var index = 0;
    window.setInterval(function () {
      items[index].style.display = 'none';
      index = (index + 1) % items.length;
      items[index].style.display = 'block';
    }, interval);
  });

  /* ---------------- Hero slider ---------------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var autoplay = parseInt(hero.getAttribute('data-autoplay'), 10);

    function goTo(i) {
      slides[index].classList.remove('is-active');
      dots[index] && dots[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      dots[index] && dots[index].classList.add('is-active');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(function () { goTo(index + 1); }, autoplay);
    }
  });

  /* ---------------- Instagram carousel ---------------- */
  document.querySelectorAll('[data-instagram-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-instagram-track]');
    var prevBtn = carousel.querySelector('[data-instagram-prev]');
    var nextBtn = carousel.querySelector('[data-instagram-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function step() {
      var item = track.querySelector('.instagram-carousel__item');
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
    }

    function updateNavState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateNavState);
    window.addEventListener('resize', updateNavState);
    updateNavState();
  });

  /* ---------------- Scroll reveal ---------------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll('.section, .collection-grid__item, .product-grid__item');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealTargets.forEach(function (el) {
      el.setAttribute('data-scroll-reveal', '');
      observer.observe(el);
    });
  }

  /* ---------------- Recover password toggle (login page) ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-recover-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var recoverForm = document.querySelector('.account-section__recover');
    if (recoverForm) {
      recoverForm.classList.add('is-visible');
      recoverForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  if (window.location.hash === '#recover') {
    var recoverForm = document.querySelector('.account-section__recover');
    if (recoverForm) recoverForm.classList.add('is-visible');
  }

  /* ---------------- Address book: new/edit toggles + delete confirm ---------------- */
  document.addEventListener('click', function (e) {
    var newToggle = e.target.closest('[data-address-new-toggle]');
    if (newToggle) {
      var form = document.querySelector('[data-address-form-new]');
      if (form) form.hidden = !form.hidden;
      return;
    }
    var editToggle = e.target.closest('[data-address-edit-toggle]');
    if (editToggle) {
      var id = editToggle.getAttribute('data-address-edit-toggle');
      var editForm = document.querySelector('[data-address-form-edit="' + id + '"]');
      if (editForm) editForm.hidden = !editForm.hidden;
      return;
    }
    var deleteBtn = e.target.closest('[data-confirm-delete]');
    if (deleteBtn) {
      if (!window.confirm(deleteBtn.getAttribute('data-confirm-message') || 'Delete this address?')) {
        e.preventDefault();
      }
    }
  });

  /* ---------------- Wishlist (localStorage-based) ---------------- */
  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem('theme:wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }
  function setWishlist(list) {
    try {
      window.localStorage.setItem('theme:wishlist', JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  }
  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', list.indexOf(id) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); } else { list.push(id); }
    setWishlist(list);
    refreshWishlistButtons();
  });
  refreshWishlistButtons();

  /* ---------------- Address country/province select ---------------- */
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    document.querySelectorAll('[data-address-country-select]').forEach(function (countrySelect) {
      var wrap = countrySelect.closest('form') || document;
      var provinceSelect = wrap.querySelector('[data-address-province-select]');
      var provinceWrap = wrap.querySelector('[data-address-province-wrap]');
      if (provinceSelect) {
        new Shopify.CountryProvinceSelector(countrySelect.id, provinceSelect.id, {
          hideElement: provinceWrap ? provinceWrap.id : null
        });
      }
    });
  }
})();
